if (!customElements.get("collection-carousel")) {
  class CollectionCarouselSlide extends HTMLElement {
    constructor() {
      super();

      const wrapCarousel = this.getAttribute("id");

      new Swiper(`#${wrapCarousel} .collection-carousel-swiper`, {
        autoHeight: false,
        allowTouchMove: true,
        slidesPerView: 2,
        spaceBetween: 16,

        // ✅ this is the one you want
        centerInsufficientSlides: true,

        // ✅ prevents weird nav/centering when slides <= slidesPerView
        watchOverflow: true,
        loop: false,

        navigation: {
          nextEl: `#${wrapCarousel} .collection-carousel-button-next`,
          prevEl: `#${wrapCarousel} .collection-carousel-button-prev`,
        },
        pagination: {
          el: `#${wrapCarousel} .swiper-pagination`,
          clickable: true,
        },
        breakpoints: {
          749: {
            slidesPerView: 4,
            spaceBetween: 24,
            centerInsufficientSlides: true,
          },
        },
      });
    }
  }
  customElements.define("collection-carousel", CollectionCarouselSlide);
}
